import type { ReactNode } from 'react';
import { ArrowRight } from '../../ui/icons';
import { cn } from '../../../lib/cn';

export function PrimaryButton({
  children,
  onClick,
  type = 'button',
  disabled,
  busy,
  variant = 'dark'
}: {
  children: ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  busy?: boolean;
  variant?: 'dark' | 'green';
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || busy}
      className={cn(
        'tap flex w-full items-center justify-center gap-2 rounded-full py-[15px] text-[15px] font-extrabold tracking-snug text-white disabled:opacity-50',
        variant === 'green'
          ? 'bg-gradient-to-br from-accent to-accent-deep shadow-featured'
          : 'bg-night shadow-dark'
      )}
    >
      {busy ? 'One moment…' : children}
      {!busy && <ArrowRight width={17} height={17} strokeWidth={2.6} />}
    </button>
  );
}
